import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
// eslint-disable-next-line
import { useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import Loading from 'src/components/Loading/Loading';
import { SearchBoxMenu } from './EventsTab.style';
import { SearchEvents } from 'src/components/CustomersBar/SearchEvents/SearchEvents';
import { EventsTabState } from 'src/components/CustomersBar/EventsTab/EventTab.state';
import { ArrowIconWrapper, MenuButtonWrapper, MenuItemsNavigation } from 'src/components/Menu/Menu.style';

interface SportTabTypes {
    isActive: boolean;
    label: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const SportTab = (props: SportTabTypes): JSX.Element => {
    const { label, isActive, onClick } = props;
    return (
        <MenuButtonWrapper
            isActive={isActive}
            onClick={onClick}
            data-test='telebet-sports-list-item'
        >
            {label}
            <ArrowIconWrapper
                isActive={isActive}
                position='right'
            />
        </MenuButtonWrapper>
    );
};

export interface EventsTabPropsType {
    label: string;
    id: number;
}

export const EventsTab = observer('EventsTab', (propsIn: EventsTabPropsType) => {
    const props = useAsObservableSource(propsIn);
    const { eventsTabState, routerBackoffice } = useAppStateContext();

    const [localState] = useState(() => new EventsTabState(props, routerBackoffice));
    return (
        <>
            <SearchBoxMenu>
                <SearchEvents redirect={localState.redirectToSearchEvent} />
            </SearchBoxMenu>

            <MenuItemsNavigation data-test='telebet-sports-list'>
                {eventsTabState.sports.map((sport) => {
                    return (
                        <SportTab
                            isActive={eventsTabState.currentActiveTab === sport.id}
                            key={sport.id}
                            label={sport.name}
                            onClick={eventsTabState.handleTabClick(sport.id)}
                        />
                    );
                })}
            </MenuItemsNavigation>

            <Loading
                message='Loading events...'
                active={eventsTabState.isLoadingActive}
            />
        </>
    );
});
